<template>
    <div>
      <b-card no-body >
        <b-card-body>
          <b-row>
            <b-col
            sm="12"
            md="2"
            class="mt-2"
            >
              <b-form-group>
                <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="obtenerProgRiego"
                :disabled="loading"
                v-b-tooltip.hover.top="'Recargar Datos'"
                >
                  <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
                </b-button>
                <b-button
                variant="gradient-primary"
                size="sm" class="mr-1"
                :disabled="loadingExcel"
                @click="descargarExcel()"
                v-b-tooltip.hover.top="'Descargar Excel'"
                >
                  <font-awesome-icon v-if="loadingExcel" icon="fa-solid fa-arrows-rotate" spin />
                  <font-awesome-icon v-else icon="fa-solid fa-download"/>
                </b-button>
                <!-- <b-button
                variant="gradient-primary"
                size="sm" class="mr-1"
                :disabled="loadingExcelBD"
                @click="descargarBD()"
                v-b-tooltip.hover.top="'Descargar BD'"
                >
                  <font-awesome-icon v-if="loadingExcelBD" icon="fa-solid fa-arrows-rotate" spin />
                  <font-awesome-icon v-else icon="fa-solid fa-database"/>
                </b-button> -->
              </b-form-group>
            </b-col>

            <b-col
            sm="12"
            md="2"
            >
              <b-form-group
              label="Empresa"
              label-for="empresa"
              >
                <v-select
                id="empresa"
                v-model="empresa"
                :options="empresas"
                @input="aplicarFiltros"
                multiple
                class="select-size-sm"
                placeholder="Seleccionar empresa ..."
                />
              </b-form-group>
            </b-col>

            <b-col
            sm="12"
            md="2"
            >
              <b-form-group
              label="Cultivo"
              label-for="cultivo"
              >
                <v-select
                  id="cultivo"
                  v-model="cultivo"
                  :options="cultivos"
                  @input="aplicarFiltros"
                  multiple
                  class="select-size-sm"
                  placeholder="Seleccionar cultivo ..."
                  />
              </b-form-group>
            </b-col>

            <b-col
            sm="12"
            md="2"
            >
              <b-form-group
              label="Version"
              label-for="version"
              >
                <v-select
                id="version"
                v-model="version"
                :options="versiones"
                @input="aplicarFiltros"
                class="select-size-sm"
                placeholder="Seleccionar version ..."
                  />
              </b-form-group>
            </b-col>
          </b-row>

        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-table
        hover
        responsive
        small
        sticky-header="58vh"
        class="position-relative"
        :items="itemsFiltro"
        :fields="fields"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
        >
          <template #table-busy>
            <div class="text-center text-dark my-1">
              <b-spinner class="align-middle"></b-spinner> &emsp;
              <strong>Obteniendo datos...</strong>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>


  </template>

  <script>
    import axiosIns from '../../libs/axios'
    import vSelect from 'vue-select'
    import ToastificationContent from '@core/components/toastification/ToastificationContent'
    import Ripple from 'vue-ripple-directive'
    import { heightTransition } from '@core/mixins/ui/transition'
    import {
      BCard,
      BCardBody,
      BFormInput,
      BRow,
      BCol,
      BFormGroup,
      BTable,
      BSpinner,
      BButton,
      BInputGroup,
      BInputGroupAppend,
      VBTooltip,
      BTooltip,
      BDropdown,
      BDropdownForm,
      BDropdownItem,
      BDropdownHeader,
      BDropdownDivider,
    } from 'bootstrap-vue'

  export default {
    components: {
      BCard,
      BCardBody,
      BCol,
      BFormInput,
      BFormGroup,
      BRow,
      BTable,
      vSelect,
      BSpinner,
      BButton,
      BInputGroup,
      BInputGroupAppend,
      VBTooltip,
      BTooltip,
      BDropdown,
      BDropdownForm,
      BDropdownItem,
      BDropdownHeader,
      BDropdownDivider,
    },
    directives: {
      'b-tooltip': VBTooltip,
      Ripple,
    },
    data: () => ({
        semanas:[],
        items_completo:[],
        items: [],
        itemsFiltro: [],
        loading: false,
        loadingExcel: false,
        loadingExcelBD: false,
        empresa: ["AGROVISION PERÚ S.A.C"],
        empresas: [
        "AGROVISION PERÚ S.A.C",
        "ARENA VERDE",
        ],
        cultivo: [],
        cultivos: [],
        version: [],
        versiones:[],

        fields: [
            {
                key: 'semana',
                label: 'semana',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'fecha',
                label: 'fecha',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'empresa',
                label: 'empresa',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'cultivo',
                label: 'cultivo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'fundo',
                label: 'fundo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'etapa',
                label: 'etapa',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'campo',
                label: 'campo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'turno',
                label: 'turno',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'variedad',
                label: 'variedad',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'lote',
                label: 'lote',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'valvula',
                label: 'válvula',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'area',
                label: 'área',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'eto',
                label: 'ETO',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'kc',
                label: 'KC',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'lr_dia',
                label: 'LR/Dia',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'descarga_caudal_hora',
                label: 'Descarga Caudal/Hora (m3/Ha)',
                class: 'text-nowrap text-center',
                sortable: true,
            },

            {
                key: 'volumen',
                label: 'Volumen Total/Dia/Turno',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclos_riego',
                label: 'Ciclos de Riego',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'riego_total',
                label: 'Riego Total',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'horas',
                label: 'Horas',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'riego_cortina',
                label: 'Riego Cortina',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'con_sin_fertilizante',
                label: 'Con/Sin Fertilizante',
                class: 'text-nowrap text-center',
                sortable: true,
            },

            {
                key: 'ciclo_1',
                label: 'Ciclo I',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_1',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_1',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_1',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_1',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'horas_inicio_seg_ciclo',
                label: 'Horas para Inicio de 2° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },

            {
                key: 'ciclo_2',
                label: 'Ciclo II',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_2',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_2',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_2',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_2',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },

            {
                key: 'horas_inicio_ter_ciclo',
                label: 'Horas para Inicio de 3° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclo_3',
                label: 'Ciclo III',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_3',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_3',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_3',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_3',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            // -----------------------
            {
                key: 'horas_inicio_cuarto_ciclo',
                label: 'Horas para Inicio de 4° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclo_4',
                label: 'Ciclo IV',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_4',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_4',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_4',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_4',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },


            {
                key: 'horas_inicio_quinto_ciclo',
                label: 'Horas para Inicio de 5° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclo_5',
                label: 'Ciclo V',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_5',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_5',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_5',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_5',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },


            {
                key: 'horas_inicio_sexto_ciclo',
                label: 'Horas para Inicio de 6° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclo_6',
                label: 'Ciclo VI',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_6',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_6',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_6',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_6',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },


            {
                key: 'horas_inicio_septimo_ciclo',
                label: 'Horas para Inicio de 7° Ciclo',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'ciclo_7',
                label: 'Ciclo VII',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_uno_7',
                label: 'Estanque 1',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_dos_7',
                label: 'Estanque 2',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estanque_tres_7',
                label: 'Estanque 3',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'hora_inicio_7',
                label: 'Hora de Inicio',
                class: 'text-nowrap text-center',
                sortable: true,
            },

            // -----------------
            {
                key: 'comentarios',
                label: 'Comentarios',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'estado',
                label: 'estado',
                class: 'text-nowrap text-center',
                sortable: true,
            },
            {
                key: 'cod_homologado',
                label: 'Cod.  Homologado',
                class: 'text-nowrap text-center',
                sortable: true,
            },
        ],

    }),
    computed: {},
    async mounted() {
      await this.obtenerProgRiego();
    },
    methods: {
      obtenerProgRiego(){
        const yo = this
        yo.loading = true
        const config = {
          method: 'get',
          url: '/pagricolas/riego/reportes/',
        }

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.items_completo = response.data;
              yo.items = response.data;
              console.log(response.data)
              yo.aplicarFiltros()

              //Obtengo las semanas para agregarlas como columnas en la tabla
              const semanas = new Set();
              yo.items.forEach(item => {

                if(!yo.cultivos.includes(item.cultivo)){
                  yo.cultivos.push(item.cultivo)
                }

                if(!yo.versiones.includes(item.version)){
                  yo.versiones.push(item.version)
                }

              });

            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loading = false
          })
      },

      aplicarFiltros(){
        const yo = this
        yo.itemsFiltro = []
        let datosFiltrados = []

        // Filtrar los elementos por cultivo y variedad
        datosFiltrados = yo.items_completo.filter(item => {

          const empresaCoincide = yo.empresa.includes(item.empresa);

          const cultivoCoincide = yo.cultivo.length === 0 || yo.cultivo.includes(item.cultivo);
          const versionCoincide = yo.version.length === 0 || yo.version.includes(item.version);

          return empresaCoincide && cultivoCoincide && versionCoincide;
        })

        yo.itemsFiltro = datosFiltrados

      },

      descargarExcel(){
        const yo = this
        let datos=[]
        const data = JSON.stringify(
          {
            "datas": yo.itemsFiltro,
            "id_user": yo.id_user,
            "semanas": yo.semanas
          }
        )
        const config = {
          method: 'post',
          url: '/pagricolas/riego/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

    },
  }
  </script>

  <style lang="scss">

    .alinear-una-sola-linea {
      white-space: nowrap !important;
    }

    .alinear-medio {
      vertical-align: middle !important;
    }

    .cabecera{
      height: 35px;
    }

  </style>
